import React from "react";
import {isRouteErrorResponse, useNavigate} from "react-router-dom";
import {EnvironmentUtility} from "./EnvironmentUtility";
import {Constants} from "./Constants";

export function RootErrorDisplay({error}: {error: unknown}) {
    let navigate = useNavigate();

    if (isRouteErrorResponse(error)) {
        return (
            <>
                <h1>
                    {error.status} {error.statusText}
                </h1>
                <p>{error.data}</p>
            </>
        );
    } else if (error instanceof Error) {
        if (EnvironmentUtility.inTestingEnvironment()) {
            return (
                <div>
                    <h1>Error</h1>
                    <p>{error.message}</p>
                    <p>The stack trace is:</p>
                    <pre>{error.stack}</pre>
                </div>
            );
        } else {
            return (
                <div>
                    <h1>Something went wrong</h1>
                    <p>An unexpected error occurred.</p>
                    <div
                        className="root-error-display-dashboard-link"
                        onClick={() => navigate(`/${Constants.routes.dispatch.pathSegment}`)}
                    >
                        Return to Dispatch
                    </div>
                </div>
            );
        }
    } else {
        return <h1>Unknown Error</h1>;
    }
}
